module.exports = "/virtual-football/img/video/video-mega-jackpot.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/video-mega-jackpot.png
// module id = 313
// module chunks = 6